(function ($) {
  $(function () {
    if ($(".t-template-our-plots").length) {
      $(".js-plot-map-pin").on("click", function () {
        const park_id = $(this).data("id");

        $(".js-plot-info").addClass("d-none");

        $(".plot-map-wrapper").addClass("mobile-d-none");

        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(`.js-plot-info[data-parkinfo="main"]`).removeClass("d-none");
        } else {
          $(".js-plot-map-pin").removeClass("active");
          $(this).addClass("active");
          $(`.js-plot-info[data-parkinfo="${park_id}"]`).removeClass("d-none");
        }
      });

      $(".js-close-plot-map").on("click", function () {
        $(".js-plot-map-pin").removeClass("active");
        $(".js-plot-info").addClass("d-none");
        $(`.js-plot-info[data-parkinfo="main"]`).removeClass("d-none");
        $(".plot-map-wrapper").removeClass("mobile-d-none");
      });
    }

    $(".js-read-more-services-new").on("click", function () {
      $(".m-card-services-new__inner").removeClass("bigger");
      const $target = $(this).parent().parent().parent();
      $target.addClass("bigger");
    });

    $(".js-close-read-more-services").on("click", function () {
      const $target = $(this).parent();
      $target.removeClass("bigger");
    });

    $(".m-card-services-new__inner").on("click", function (e) {
      console.log("helo");
      $(this).toggleClass("mobile-active");
    });
  });
})(jQuery);
